import React from 'react';
import { Filter } from 'lucide-react';
import { FilterState } from '../types';
import { useLanguage } from '../../../../contexts/LanguageContext';

type Props = {
  filters: FilterState;
};

export const ActiveFilters = ({ filters }: Props) => {
  const { translations } = useLanguage();

  if (!filters.search && !filters.status && !filters.country && !filters.ownership) {
    return null;
  }

  const getStatusLabel = (status: string) => {
    switch (status) {
      case 'approved':
        return translations?.activeFilters?.statusApproved || 'Approved';
      case 'pending':
        return translations?.activeFilters?.statusPending || 'Pending';
      case 'disputed':
        return translations?.activeFilters?.statusDisputed || 'Disputed';
      case 'rejected':
        return translations?.activeFilters?.statusRejected || 'Rejected';
      default:
        return status;
    }
  };

  const getOwnershipLabel = (ownership: string) => {
    switch (ownership) {
      case 'owner':
        return translations?.activeFilters?.isOwner || 'Is Owner';
      case 'notOwner':
        return translations?.activeFilters?.notOwner || 'Not Owner';
      default:
        return ownership;
    }
  };

  return (
    <div className="flex items-center gap-2">
      <Filter size={16} className="text-primary-500" />
      <span className="text-sm text-gray-600">
        {translations?.activeFilters?.activeFiltersLabel || 'Active Filters:'}
      </span>
      <div className="flex flex-wrap gap-2">
        {filters.search && (
          <span className="text-xs bg-primary-50 text-primary-700 px-2 py-1 rounded">
            {translations?.activeFilters?.searchLabel || 'Search:'}{' '}
            {filters.search}
          </span>
        )}
        {filters.status && (
          <span className="text-xs bg-primary-50 text-primary-700 px-2 py-1 rounded">
            {translations?.activeFilters?.statusLabel || 'Status:'}{' '}
            {getStatusLabel(filters.status)}
          </span>
        )}
        {filters.country && (
          <span className="text-xs bg-primary-50 text-primary-700 px-2 py-1 rounded">
            {translations?.activeFilters?.countryLabel || 'Country:'}{' '}
            {filters.country}
          </span>
        )}
        {filters.ownership && (
          <span className="text-xs bg-primary-50 text-primary-700 px-2 py-1 rounded">
            {translations?.activeFilters?.ownershipLabel || 'Ownership:'}{' '}
            {getOwnershipLabel(filters.ownership)}
          </span>
        )}
      </div>
    </div>
  );
};